<template>
    <aside class="ProjectViewOrgInfoBlock mb-20">
        <CHeading :variant="3">
            {{ orgProfileHeadlineText }}
        </CHeading>

        <CCardBox>
            <div class="mb-8">
                <div class="flex items-start justify-between space-x-3">
                    <CHeading class="flex-auto self-center" variant="4">
                        {{ org.title }}
                    </CHeading>

                    <CThumbnailImage :alt="org.title" class="w-11 flex-none" :src="org.image" type="org" />
                </div>

                <div class="mb-1.5 mt-1 text-smaller leading-5 text-gray-800 dark:text-txt-headings">
                    {{ organizationType }}
                </div>

                <div v-if="hasAddress" class="text-smaller leading-5">
                    <template v-if="org.address"> {{ org.address }}<br /> </template>

                    <template v-if="org.zip || org.geocity">
                        {{ org.zip }}
                        {{ org.geocity }}<br />
                    </template>

                    <template v-if="org.country">
                        {{ org.country }}
                    </template>
                </div>
            </div>

            <CButton v-if="org.web" full :href="formatedUrl(org.web)" icon="web" target="_blank">
                Webové stránky
            </CButton>

            <CButton
                full
                :to="{
                    name: 'orgs-id',
                    params: {
                        id: org.slug || org.id
                    }
                }"
                variant="secondary"
            >
                {{ orgProfileLinkText }}
            </CButton>
        </CCardBox>
    </aside>
</template>

<script setup lang="ts">
import { orgTypeProfileAboutText, orgTypeProfileLinkText, orgTypes, valueLookup } from '#shared/types/dictionary'
import type { Org } from '#shared/types/Org'

const props = defineProps<{
    org: Org
}>()

const hasAddress = computed((): boolean => {
    return Boolean(props.org?.address || props.org?.zip || props.org?.geocity || props.org?.country)
})

const organizationType = computed((): string => {
    return valueLookup(props.org.type, orgTypes)
})

const orgProfileHeadlineText = computed((): string => {
    return orgTypeProfileAboutText(props.org.type)
})

const orgProfileLinkText = computed((): string => {
    return orgTypeProfileLinkText(props.org.type)
})

const formatedUrl = (web: string) => {
    if (!web) {
        return false
    }
    return (web.indexOf('http://') !== 0 && web.indexOf('https://') !== 0 ? 'http://' : '') + web
}
</script>